import { getAdaptiveCareLensKey } from './adaptiveQuickLogConfig';

const DEFAULT_BATHROOM_LOG_CONFIG = {
  title: 'Bathroom',
  subtitle: 'Log what happened - takes 10 seconds.',
  eventSectionLabel: 'What happened?',
  locationSectionLabel: 'Location',
  typeOptions: [
    { value: 'Urination', label: 'Urination' },
    { value: 'Bowel movement', label: 'Bowel movement' },
    { value: 'Both', label: 'Both' },
    { value: 'Accident', label: 'Accident' },
  ],
  locationOptions: [
    { value: 'Home', label: 'Home' },
    { value: 'School', label: 'School' },
    { value: 'Community', label: 'Community' },
    { value: 'Car', label: 'Car' },
    { value: 'Other', label: 'Other' },
  ],
  stoolScaleLabel: 'Bristol stool scale',
  stoolScaleHint: 'Select a type if you want to track stool consistency',
  notesLabel: 'Notes',
  notesPlaceholder: 'Any additional context',
  saveLabel: 'Save bathroom log',
  savedTitle: 'Bathroom',
  savedTitlePrefix: 'Bathroom',
  savedFallbackText: 'Bathroom logged',
};

const BATHROOM_LOG_CONFIG_BY_LENS = {
  hospice: {
    ...DEFAULT_BATHROOM_LOG_CONFIG,
    title: 'Bathroom & Comfort',
    subtitle: 'Log toileting, bowel changes, accidents, and comfort context.',
    eventSectionLabel: 'What toileting or bowel change happened?',
    locationSectionLabel: 'Where did it happen?',
    typeOptions: [
      { value: 'Urination', label: 'Urination' },
      { value: 'Bowel movement', label: 'Bowel movement' },
      { value: 'Both', label: 'Both' },
      { value: 'Accident', label: 'Leak / accident' },
    ],
    locationOptions: [
      { value: 'Bed', label: 'Bed' },
      { value: 'Bathroom', label: 'Bathroom' },
      { value: 'Commode', label: 'Commode' },
      { value: 'Brief / pad', label: 'Brief / pad' },
      { value: 'Other', label: 'Other' },
    ],
    stoolScaleLabel: 'Stool consistency',
    stoolScaleHint: 'Track stool consistency only when it helps comfort or care decisions.',
    notesLabel: 'Comfort notes',
    notesPlaceholder: 'Add pain, privacy, skin, positioning, or cleanup context.',
    saveLabel: 'Save bathroom & comfort',
    savedTitle: 'Bathroom & Comfort',
    savedTitlePrefix: 'Bathroom & Comfort',
    savedFallbackText: 'Bathroom and comfort logged',
  },
};

export const getAdaptiveBathroomLogConfig = (child = {}) => (
  BATHROOM_LOG_CONFIG_BY_LENS[getAdaptiveCareLensKey(child)] || DEFAULT_BATHROOM_LOG_CONFIG
);

const getBathroomEntryLensKey = (entry = {}) => (
  entry?.adaptiveBathroomLogLens
  || entry?.bathroomDetails?.adaptiveBathroomLogLens
  || ''
);

export const resolveAdaptiveBathroomLogPresentation = ({ entry = {}, child = null } = {}) => {
  const entryLensKey = getBathroomEntryLensKey(entry);
  const config = entryLensKey
    ? (BATHROOM_LOG_CONFIG_BY_LENS[entryLensKey] || DEFAULT_BATHROOM_LOG_CONFIG)
    : getAdaptiveBathroomLogConfig(child || {});
  const title = entry?.adaptiveBathroomLogLabel
    || entry?.bathroomDetails?.adaptiveBathroomLogLabel
    || config.savedTitle
    || config.title
    || DEFAULT_BATHROOM_LOG_CONFIG.title;

  return {
    lensKey: entryLensKey || getAdaptiveCareLensKey(child || {}),
    categoryLabel: title,
    title,
    titlePrefix: config.savedTitlePrefix || title,
    locationLabel: config.locationSectionLabel || DEFAULT_BATHROOM_LOG_CONFIG.locationSectionLabel,
    stoolScaleLabel: config.stoolScaleLabel || DEFAULT_BATHROOM_LOG_CONFIG.stoolScaleLabel,
    notesLabel: config.notesLabel || DEFAULT_BATHROOM_LOG_CONFIG.notesLabel,
    fallbackText: config.savedFallbackText || DEFAULT_BATHROOM_LOG_CONFIG.savedFallbackText,
  };
};
